import Dropdown from "./dropdown";

const DATE_COMPARISONS = [
  { value: "lt", label: "Less than" },
  { value: "gt", label: "Greater than" },
  { value: "between", label: "Between" },
];

const DateComparisonDropdown = ({ handleChange, value, name }) => {
  return (
    <Dropdown
      handleChange={handleChange}
      value={value}
      name={name}
      options={DATE_COMPARISONS}
    />
  );
};

export default DateComparisonDropdown;
